const DDZT_ENUM =  {
  '1': '待处理',
  '2': '已完成',
  '3': '已忽略',
  '4': '处理中',
}

/**
 * 酒店需求单类
 */
export default class HotelNeedOrder {
  constructor(order = {}) {
    Object.assign(this, order)
  }
  
  get ddztRemark () {
    return DDZT_ENUM[this.ddzt]
  }
}